import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CheckCircleIcon } from 'lucide-react';
export function ApproachComparison() {
  const dealershipWorkflow = ['Fault code points to likely component', 'Service advisor summarizes technician findings', 'Repair estimate presented for approval'];
  const lancerWorkflow = ['Full-system inspection to confirm the real cause before replacing parts', 'Digital inspection report with photos and video from your vehicle', 'Repairs prioritized by urgency so you decide what to fix now vs later', 'Clear explanation of what we found and why before any repair begins'];
  return <section className="py-20 px-4 bg-brand-dark text-white" data-id="element-20">
      <div className="max-w-6xl mx-auto" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-22">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-23">
            Dealership vs. Lancer
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold mb-6" data-id="element-24">
            A different approach to diagnosing problems
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 mb-12" data-id="element-25">
          {/* Dealership Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-gray-800/50 border border-gray-700 rounded-2xl p-8 md:p-10" data-id="element-26">
            <h3 className="font-heading uppercase tracking-wide text-xl font-bold text-gray-400 mb-8 pb-4 border-b border-gray-700" data-id="element-27">
              A common repair workflow
            </h3>
            <ul className="space-y-6" data-id="element-28">
              {dealershipWorkflow.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-29">
                  <XCircleIcon className="w-6 h-6 text-gray-500 flex-shrink-0 mt-0.5" data-id="element-30" />
                  <span className="text-gray-300 text-lg" data-id="element-31">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Lancer Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gray-800 border-2 border-brand-accent rounded-2xl p-8 md:p-10 relative shadow-2xl shadow-brand-accent/10" data-id="element-32">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-brand-dark font-bold px-4 py-1 rounded-full text-sm" data-id="element-33">
              The Lancer Way
            </div>
            <h3 className="font-heading uppercase tracking-wide text-xl font-bold text-white mb-8 pb-4 border-b border-gray-700" data-id="element-34">
              Lancer diagnostic approach
            </h3>
            <ul className="space-y-6" data-id="element-35">
              {lancerWorkflow.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-36">
                  <CheckCircleIcon className="w-6 h-6 text-brand-accent flex-shrink-0 mt-0.5" data-id="element-37" />
                  <span className="text-white font-medium text-lg" data-id="element-38">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-39">
          <p className="text-xl text-brand-accent font-semibold" data-id="element-40">
            You should understand the problem before deciding on the repair.
          </p>
        </motion.div>
      </div>
    </section>;
}